import Typewriter from '../vendor/typewriter';

const professionWrapper = document.querySelector('#home-title span');
let counter = 0;
const professions = ["K12 School", "Vocational School", "Preschool", "Faith-Based School", "Music School", "Art School"]


function updateTitles() {
    professionWrapper.innerHTML = '';
    counter = (counter == professions.length - 1) ? 0 : counter + 1;
    professionWrapper.innerHTML += professions[counter];
}

window.addEventListener('DOMContentLoaded', () => {
    if (document.querySelector('#home-title')) {

        new Typewriter('#home-title span', {
            strings:  ["K12 School", "Vocational School", "Preschool", "Faith-Based School", "Music School", "Art School"],
            autoStart: true,
            loop: true,
            delay: 50
        });
    }
})